import { MenuItem, Select } from "@/components/shared";
import { AssetIcon, safeAssetIconName } from "@/components";
import { TOKEN_CONFIG } from "@/config";
import type { TokenId } from "@/types";
import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export interface TokenSelectProps {
    value: TokenId;
    onChange: (value: TokenId) => void;
    options: TokenId[];
    readonly?: boolean;
}

export function TokenSelect({ value, onChange, options, readonly }: TokenSelectProps) {
    const [open, setOpen] = useState(false);

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        readonly || onChange(event.target.value as TokenId);
        onChange(event.target.value as TokenId);
    };

    const handleOpen = () => {
        readonly || setOpen(true);
    };

    const handleClose = () => {
        readonly || setOpen(false);
    };

    return (
        <Select
            open={open}
            onOpen={handleOpen}
            onClose={handleClose}
            value={value}
            onChange={handleChange}
            displayEmpty
            readOnly={readonly}
            slotProps={{
                input: {
                    "aria-label": "Select token",
                    className:
                        "py-1 pl-3 pr-8 rounded-[4px] bg-primary/10 hover:bg-primary/5 border-primary/5 hover:cursor-pointer",
                },
            }}
            className="flex items-center px-0 rounded-[8px] text-primary focus:outline-none focus:ring-0 focus:ring-transparent"
            IconComponent={() => (
                <ChevronDownIcon className="w-5 h-5 text-primary absolute right-2 pointer-events-none" />
            )}
        >
            {options.map((tokenId) => (
                <MenuItem key={tokenId} value={tokenId}>
                    <div className="flex items-center gap-1">
                        <AssetIcon name={safeAssetIconName(tokenId)} className="aspect-square w-[17px] h-[17px]" />
                        <div className="text-[15px] whitespace-nowrap">{TOKEN_CONFIG[tokenId].symbol}</div>
                    </div>
                </MenuItem>
            ))}
        </Select>
    );
}
